export enum CustomerPortalVersion {
  /* Old returns */
  V3_5 = "v3.5",
  V4_0 = "v4.0",
}
